<template>
  <div 
    class="shadow-md rounded-xl p-6 text-white group"
    :style="{ backgroundImage: 'linear-gradient(to bottom, #FED803, #D91C5E)' }"
  >
    <div class="flex justify-between items-center">
      <h2 class="text-xl font-semibold">Your RSS Feed</h2>
      <div class="transition-transform duration-300 ease-in-out group-hover:scale-110 group-hover:rotate-6">
        <svg class="w-8 h-8 opacity-75" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"></path></svg>
      </div>
    </div>
    <p class="mt-2 text-sm opacity-80">
      Submit this link to directories like Spotify & Apple Podcasts.
    </p>
    <div class="mt-4 flex items-center bg-black bg-opacity-25 rounded-md">
      <input 
        :value="rssFeedUrl" 
        readonly 
        type="text" 
        class="p-2 bg-transparent w-full text-white text-sm focus:outline-none"
      >
      <button 
        @click="copyUrl"
        :disabled="isCopied"
        class="flex-shrink-0 px-4 py-2 text-sm font-semibold rounded-r-md transition-colors"
        :class="isCopied ? 'bg-green-500 text-white' : 'bg-white/80 text-purple-800 hover:bg-white'"
      >
        <span v-if="isCopied">Copied!</span>
        <span v-else>Copy</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'RssFeedDisplayPanel',
  data() { return { isCopied: false, }; },
  computed: {
    ...mapState(['clientId']),
    rssFeedUrl() {
      if (!this.clientId) { return 'Loading feed URL...'; }
      const functionUrl = `https://europe-west2-castive-prod.cloudfunctions.net/generateRssFeed`;
      return `${functionUrl}/${this.clientId}`;
    },
  },
  methods: {
    copyUrl() {
      if (!this.rssFeedUrl || this.isCopied) return;
      navigator.clipboard.writeText(this.rssFeedUrl).then(() => {
        this.isCopied = true;
        setTimeout(() => { this.isCopied = false; }, 2500);
      }).catch(err => {
        console.error('Failed to copy RSS URL: ', err);
        alert('Failed to copy URL.');
      });
    },
  },
};
</script>